import { CollabType as BriefCollabType } from '@fluenceur/types';
import { VideoCamera, Gift, Link, Megaphone } from 'iconoir-react';
import type { ComponentType, SVGProps } from 'react';

/** The collaboration kinds a brand can propose to a creator. */
export type CollabType = 'affiliation' | 'sponsored' | 'ugc' | 'gifting';

/** The two kinds the collab wizard proposes, each built on a brief of its own type. */
export type CollabWizardType = Extract<CollabType, 'sponsored' | 'ugc'>;

/** The wizard path a brief of this type is proposed through. */
export const wizardTypeOfBrief = (type: BriefCollabType | null | undefined): CollabWizardType =>
  type === BriefCollabType.UGC ? 'ugc' : 'sponsored';

/** The brief type the wizard lists on this path. */
export const briefTypeOfWizard = (
  type: CollabType | null | undefined
): BriefCollabType.SPONSORED_POST | BriefCollabType.UGC =>
  type === 'ugc' ? BriefCollabType.UGC : BriefCollabType.SPONSORED_POST;

export interface CollabTypeOption {
  type: CollabType;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  titleKey: string;
  descriptionKey: string;
  /** Non-shippable kinds carry a "soon" badge; a fresh kind carries "new". */
  badge?: 'soon' | 'new';
  enabled: boolean;
}

/**
 * Type-step catalogue. Affiliation, Sponsored post and UGC ship today (the
 * sponsored post carries a "New" badge); Gifting is shown disabled with a
 * "Soon" badge so the brand sees the roadmap. UGC is offered only to a brand
 * offered UGC: the type step hides it from any other rather than show it as
 * coming.
 */
export const COLLAB_TYPE_OPTIONS: CollabTypeOption[] = [
  {
    type: 'affiliation',
    icon: Link,
    titleKey: 'invitations.modal.collab.types.affiliation.title',
    descriptionKey: 'invitations.modal.collab.types.affiliation.description',
    enabled: true,
  },
  {
    type: 'sponsored',
    icon: Megaphone,
    titleKey: 'invitations.modal.collab.types.sponsored.title',
    descriptionKey: 'invitations.modal.collab.types.sponsored.description',
    badge: 'new',
    enabled: true,
  },
  {
    type: 'ugc',
    icon: VideoCamera,
    titleKey: 'invitations.modal.collab.types.ugc.title',
    descriptionKey: 'invitations.modal.collab.types.ugc.description',
    enabled: true,
  },
  {
    type: 'gifting',
    icon: Gift,
    titleKey: 'invitations.modal.collab.types.gifting.title',
    descriptionKey: 'invitations.modal.collab.types.gifting.description',
    badge: 'soon',
    enabled: false,
  },
];
